var AppBridge = window["app-bridge"];
var createApp = AppBridge.createApp;
import {user} from './firebase'
import {APP_API_KEY} from './globals'
export const host = (new URLSearchParams(window.location.search)).get("host")
export let app = {}
export let getSessionToken = () => {}
export let authenticatedFetch = () => {}
if (host) {
    /* running in shopify */
    app = createApp({
        apiKey: APP_API_KEY,
        host: host
    });
    const realGetSessionToken = window['app-bridge-utils'].getSessionToken
    getSessionToken = () => {
        return realGetSessionToken(app)
    };
    
    authenticatedFetch = async (url, params = {}) => {
        const token = await getSessionToken()
        console.log({with: "shopify",token})
        const resp = await window.fetch(url, {
            ...params,
            headers: {
                ...params.headers,
                "Authorization": "Bearer " + token,
                "X-Requested-With": "shopify"
            }
        })
        return resp
    }
} else {
    /* running standalone */
    authenticatedFetch = async (url, params = {}) => {
        const token = await user.auth.getIdToken()
        console.log({with: "firebase",token})
        const resp = await window.fetch(url, {
            ...params,
            headers: {
                ...params.headers,
                "Authorization": "Bearer " + token,
                "X-Requested-With": "firebase"
            }
        })
        return resp
    }
}
